import {getLoginToken, resetStore} from './store'
import gql from 'graphql-tag'

export default async function(apollo) {
  const token = await getLoginToken()
  await resetStore()

  if (!token) return

  apollo.mutate({
    mutation: gql`
      mutation logout {
        logout {
          success
        }
      }
    `,
    variables: {
      token
    }
  })
}



// WEBPACK FOOTER //
// ./src/App/helpers/meteor-apollo-accounts/logout.js